import { TbRefresh, TbCheck } from "react-icons/tb";

export default function Refresh({ handleRefresh, showCheckmark, refreshing, ...rest }) {
  return (
    <button onClick={handleRefresh} className='refresh-button' disabled={refreshing || showCheckmark} {...rest}>
        {showCheckmark ? <TbCheck className='refresh-icon' /> : <TbRefresh className={`refresh-icon${refreshing ? ' rotating' : ''}`} />}
    </button>
  )
}
